// extracted by mini-css-extract-plugin
module.exports = {"root":"EXnHg5Ag","label":"LlqfnwhV"};